import angular from "angular";

import AdminServicesModuleRouting from "./admin-services.module.routing";

export default angular
  .module("vt-admin-services", [])
  .config(AdminServicesModuleRouting);
